<template>
  <div>
    <group-form
      :is-group-form-sidebar-active.sync="isGroupFormSidebarActive"
          :group-data="groupData"
          @refetch-data="refetchData" 
      />
      <comment-form
      :is-comment-form-sidebar-active.sync="isCommentFormSidebarActive"
          :comment-data="commentData"
          @refetch-data="refetchData" 
      />
      <b-card no-body
      >
        <div class="m-2">
          <div class="d-flex align-items-center justify-content-end">
              <b-form-group
              label="Choose your platform to display website"
              label-for="group_id"
              >
              <v-select
                  id="group_id"
                  class="d-inline-block width-350 mr-1"
                      v-model="catFilter"
                      placeholder="Choose your platform to display"
                      label="title"
                      :reduce="(option) => option.id"
                      :options="groups"
              />
              </b-form-group>
              <b-button
              variant="primary"
              @click="addGroup"
            >
              <span class="text-nowrap">Add Group</span>
            </b-button>
          </div>
        </div>
      </b-card>

      <b-card v-for="(ng,key) in groups" :key="'group'+key" action-collapse  >
        <b-card-header class="pb-50">
          
          <b-row class="w-100">
            <b-col  cols="10">
              <h3>
                {{ ng.title }}
              </h3>
            </b-col>
            <b-col cols="2">
              <div class="d-flex align-items-center justify-content-end">
                <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="success"
                    class="btn-icon"
                    @click="updateGroup(ng)"
                  >
                    <feather-icon icon="EditIcon" />
                  </b-button>
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="danger"
                    class="btn-icon ml-1"
                    @click="deleteGroupconfirm(ng.id)"
                  >
                    <feather-icon icon="XIcon" />
                  </b-button>
              </div>
            </b-col>
          </b-row>
          
        </b-card-header>
        <b-card-body>
          <div class="d-flex align-items-center mb-2">
              <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              @click="addNav(ng.id)"
              class="btn-icon"
            >
            <feather-icon icon="PlusCircleIcon" />
            </b-button>
          </div>
          
          <draggable
            :list="ng.comments"
            tag="ul"
            @change="undateOrdering(key)"
            class="list-group list-group-flush cursor-move"
          >
            <b-list-group-item
              v-for="(itm, index) in ng.comments"
              :key="index"
              tag="li"
            >
            
                <b-row >
                  <b-col cols="10">
                    <div class="p-1" v-if="itm.iframe" v-html="itm.iframe">
                    </div>
                    <div class="d-flex">
                      <div class=" mr-2">
                        <b-img
                  :src="(itm.image?itm.fullpath:require('@/assets/images/no-image.png'))"
                 
                  width="170"
                  class="rounded m-0"
                  />
                      </div>
                      <div>
                        <b> {{  itm.name[currentLocale] }}</b>
                        <div> {{  itm.email }}</div>
                        <div> {{  itm.comment[currentLocale] }}</div>
                        <div> {{  `Rating: ${itm.rating}` }}</div>
                      </div>

                    </div>
                  </b-col>
                  <b-col cols="2">
                    <div class="d-flex  justify-content-end">
                      <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="success"
                    class="btn-icon"
                    @click="updateNav(itm)"
                  >
                    <feather-icon icon="EditIcon" />
                  </b-button>
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="danger"
                    class="btn-icon ml-1"
                    @click="deleteconfirm(itm.id)"
                  >
                    <feather-icon icon="XIcon" />
                  </b-button>
                    </div>
                  </b-col>
                </b-row>
                
               

              
            
            </b-list-group-item>
          </draggable>
          <!--<vue-drag-tree :data='data' :allowDrag='allowDrag' :allowDrop='allowDrop' :defaultText='"New Node"' @current-node-clicked='curNodeClicked' @drag="dragHandler" @drag-enter="dragEnterHandler" @drag-leave="dragLeaveHandler" @drag-over="dragOverHandler" @drag-end="dragEndHandler" @drop="dropHandler" v-slot="slotProps">
             
              <span :class="[slotProps.isClicked ? 'i-am-clicked' : 'i-am-not-clicked']"></span>
              <span class='i-am-node-name'>{{slotProps.nodeName}}</span>
          </vue-drag-tree>-->
        </b-card-body>
      </b-card>
     
  </div>
</template>
<script>


import {
BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
BBadge, BDropdown, BDropdownItem, BPagination, BTooltip,VBModal,BFormGroup,BFormCheckbox,
BListGroupItem,BCardHeader,BCardBody,BImg
} from 'bootstrap-vue'
import BCardActions from '@core/components/b-card-actions/BCardActions.vue'
import Ripple from 'vue-ripple-directive'
//api
import axios from '@axios'
import store from '@/store'
import { ref,onUnmounted, onMounted } from '@vue/composition-api'
import useCommentList from './useCommentList'
import commentStoreModule from '../commentStoreModule'
import GroupForm from '../comment-form/GroupForm.vue'
import CommentForm from '../comment-form/CommentForm.vue'

import vSelect from 'vue-select'
import draggable from 'vuedraggable'
import Prism from 'vue-prism-component'
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'

export default{
  components:{
      BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
      BBadge, BDropdown, BDropdownItem, BPagination, BTooltip,VBModal,BFormGroup,BFormCheckbox,
      BCardActions,
      Prism,
      draggable,
      BListGroupItem,
      GroupForm,
      BCardHeader,
      BCardBody,
      CommentForm,
      vSelect,
      BImg
      
      

  },
  directives:{
      'b-modal': VBModal,
      Ripple

  },
  computed: {
     
     currentLocale() {
       return  this.$i18n.locale;
     },
 },
  setup(){

    const COMMENT_STORE_MODULE_NAME = 'app-comment';
    if (!store.hasModule(COMMENT_STORE_MODULE_NAME)) store.registerModule(COMMENT_STORE_MODULE_NAME, commentStoreModule)
    onUnmounted(() => {
        if (store.hasModule(COMMENT_STORE_MODULE_NAME)) store.unregisterModule(COMMENT_STORE_MODULE_NAME)
    });

      const {
        catFilter,
        groups,
        undateOrdering,
        updateGroup,
        refetchData,
        isGroupFormSidebarActive,
        isCommentFormSidebarActive,
        groupData,
        addGroup,
        addNav,
        updateNav,
        commentData,
        deleteData,
        deleteGroupData

      } = useCommentList();
      return {
        catFilter,
        groups,
        undateOrdering,
        updateGroup,
        refetchData,
        isGroupFormSidebarActive,
        isCommentFormSidebarActive,
        groupData,
        addGroup,
        addNav,
        updateNav,
        commentData,
        deleteData,
        deleteGroupData,
      }
  },
  data(){
      return {
          data: [
              {
              name: 'Node 0-0',
              id: 0,
              children: [
                  {
                  name: 'Node 1-1',
                  id: 3,
                  children: [
                      {
                      name: 'Node 2-1',
                      id: 4,
                      children: []
                      },
                      {
                      name: 'Node 2-2',
                      id: 10,
                      children: []
                      }
                  ]
                  },
                  {
                  name: 'Node 1-2',
                  id: 13,
                  children: []
                  }
              ]
              },
              {
              name: 'Node 0-1',
              id: 14,
              children: []
              }
          ],
          comments_groups:[
              {
                  id:1,
                  title:'Header',
                  slug:'header'
              },
              {
                  id:2,
                  title:'Footer',
                  slug:'footer'
              }
          ],
          comments: [
              { text: "node 1" },
              { text: "node 2" },
              { text: "node 3 undraggable" },
              { text: "node 4" },
              { text: "node 4 undroppable", droppable: false },
          ]
      }
  },
  methods:{
    deleteconfirm(id){
              this.$bvModal
                  .msgBoxConfirm('Please confirm that you want to delete Comment ID.'+id, {
                  title: 'Please Confirm',
                  size: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  cancelVariant: 'outline-secondary',
                  hideHeaderClose: false,
                  centered: true,
                  })
                  .then(value => {
                  if(value === true){
                  this.deleteData(id)
                  }
              
                  //this.deleteData(id)
                  })
  
  },
  deleteGroupconfirm(id){
              this.$bvModal
                  .msgBoxConfirm('Please confirm that you want to delete Group ID.'+id, {
                  title: 'Please Confirm',
                  size: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  cancelVariant: 'outline-secondary',
                  hideHeaderClose: false,
                  centered: true,
                  })
                  .then(value => {
                  if(value === true){
                  this.deleteGroupData(id)
                  }
              
                  //this.deleteData(id)
                  })
  
  },
      allowDrag(model, component) {
    if (model.name === 'Node 0-1') {
      // can't be dragged
      //return false;
    }
    // can be dragged
    return true;
  },
  allowDrop(model, component) {
    if (model.name === 'Node 2-2') {
      // can't be placed
      //return false;
    }
    // can be placed
    return true;
  },
  curNodeClicked(model, component) {
    // console.log('curNodeClicked', model, component);
  },
  dragHandler(model, component, e) {
    // console.log('dragHandler: ', model, component, e);
  },
  dragEnterHandler(model, component, e) {
    // console.log('dragEnterHandler: ', model, component, e);
  },
  dragLeaveHandler(model, component, e) {
    // console.log('dragLeaveHandler: ', model, component, e);
  },
  dragOverHandler(model, component, e) {
    // console.log('dragOverHandler: ', model, component, e);
  },
  dragEndHandler(model, component, e) {
    // console.log('dragEndHandler: ', model, component, e);
  },
  dropHandler(model, component, e) {
    // console.log('dropHandler: ', model, component, e);
  },
  }
}

</script>